<template>
  <ElButton
    type="danger"
    @click="showForm = true"
  >
    {{ title }}

    <ElDialog
      append-to-body
      :title="title | ucwords"
      top="25vh"
      :visible.sync="showForm"
    >
      <p>If <strong>more than one</strong> recruiters exist for this company, continuing will remove this user as a recruiter from the company account.</p>
      <p>Are you sure you want to do that?</p>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <ElButton
          class="margin-right-unit"
          type="text"
          @click="showForm = false"
        >
          No
        </ElButton>

        <ElButton
          type="danger"
          @click="removeRecruiter()"
        >
          Yes
        </ElButton>
      </span>
    </ElDialog>
  </ElButton>
</template>

<script>
import axios from '@/axios/axios'

export default {
  name: 'RemoveRecruiter',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showForm: false
    }
  },
  computed: {
    title() {
      return 'REMOVE RECRUITER'
    }
  },
  methods: {
    removeRecruiter() {
      const data = {
        email: this.user.email
      }

      return axios.post('admin/recruiter/remove', data)
        .then(res => {
          this.showForm = false

          this.successNotification(res.data)
        })
        .catch(axios.handleError)
    }
  }
}
</script>
